// initial state
const state = {
    padlist: [],
    syncpadList: [],
    groupId: '',
    groupList: [],
    selectedPads: [],
    installedApks: [],
    chosenPads: [],
    windowNum: 1, //判断窗口多开数
    through :false, //判断是否打开了窗口
    isPop:'0',//0为跳转固定页面，1为弹窗
    routePath:'',
    controlIp:'', //群控ip
    totalPhone:0,//云机总数
    copyList:[],//剪贴板内容

    // 云机同步时所传参数
    queryIds: '',
    queryArr: [],
  };
  
  // getters
  const getters = {};
  
  // actions
  const actions = {};
  
  // mutations
  const mutations = {
    setPadlist(state, padlist) {
      //设置参数
      state.padlist = padlist;
    },
    setSyncPadList(state, syncpadList) {
      state.syncpadList = syncpadList;
    },
    setGroupId(state, groupId) {
      state.groupId = groupId;
    },
    setGroupList(state, groupList) {
      state.groupList = groupList;
    },
    setSelectedPads(state, selectedPads) {
      state.selectedPads = selectedPads
    },
    setChosenPads(state, chosenPads) {
      state.chosenPads = chosenPads
    },
    setInstalledApks(state, installedApks) {
      state.installedApks = installedApks
    },
    setWindowNum(state, windowNum) {
      state.windowNum = windowNum
    },
    setThrough(state, through) {
      state.through = through
    },
    setIsPop(state, isPop) {
      state.isPop = isPop
    },
    setRoutePath(state, routePath) {
      state.routePath = routePath
    },
    setControlIp(state, controlIp) {
      state.controlIp = controlIp
    },
    setTotalPhone(state, totalPhone) {
      state.totalPhone = totalPhone
    },
    setCopyList(state, copyList) {
      state.copyList = copyList
    },
    setQueryIds(state, ids) {
      state.queryIds = ids
    },
    setQueryArr(state, arr) {
      state.queryArr = arr
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
  


// WEBPACK FOOTER //
// ./src/store/module/padlist.js